<template>
    <VueDatePicker v-model="date" :placeholder="placeholder" @update:model-value="handleDate" :format="format"/>
  </template>
  
  <script>
  export default {
    name: 'DateComponent',
    props: {
      placeholder: {
        type: String,
        default: "Select a date", // Fallback placeholder if not provided
      },
    },
    data() {
      return {
        date: '',
      };
    },
    methods:{
        handleDate(modelData){
            this.date = modelData; 
            //const options = { year: 'numeric', month: 'short', day: '2-digit' }; 
            this.$emit('updateDate', this.format(this.date))
        },
        format(date) {
          if (!date) return '';
          const day = String(date.getDate()).padStart(2, '0');  
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const year = date.getFullYear();
          return `${year}-${month}-${day}`;
        }
    },
   
  };
  </script>
  